import { withStyles } from '@mui/styles'
import Button from '@mui/material/Button'

const ToolbarButton = withStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.backgroundColorLight,
      '&:hover': {
        backgroundColor: theme.ToolbarButton.backgroundColor,
      },
      '&:hover .MuiButton-label': {
        color: theme.primaryDark,
        fill: theme.primaryDark,
      },
      borderRadius: theme.borderRadius,
    },
    outlined: {
      padding: '13px',
      borderWidth: 0,
      borderColor: theme.ToolbarButton.borderColor,
      '&:first-child': {
        borderWidth: '1px',
        borderRightWidth: 0,
      },
      '&:last-child': {
        borderWidth: '1px',
        borderLeftWidth: 0,
      },
    },
  }
})(Button)

export default ToolbarButton
